import { Field } from 'formik';
import { CustomSelectComponent, FormCol6, FsProps } from 'motion-components';
import React from 'react';

export const ChemistryOptions = [
  { value: 'LFP', label: 'LFP' },
  { value: 'NMC111', label: 'NMC111' },
  { value: 'NMC except NMC111', label: 'NMC εκτός NMC111' },
  { value: 'LTO', label: 'LTO' },
  { value: 'LFMP', label: 'LFMP' },
  { value: 'LMO', label: 'LMO' },
  { value: 'LCO', label: 'LCO' },
  { value: 'NMO', label: 'NMO' },
  { value: 'LNCA', label: 'LNCA' },
  { value: 'Other', label: ' Άλλη, μη διαθέσιμα στοιχεία' },
];

export const ChemistryValues = ChemistryOptions.map((option) => option.value);

export const FieldSelectChemistry = ({
  label = 'Χημική σύσταση μπαταρίας;',
  name = 'xrbData.chemistry',
  as = 'div',
  disabled = false,
  ...rest
}: FsProps) => {
  //1;field;chemistry;enum('LFP','NMC','LTO','LFMP','LMO','LCO','NMO','LNCA');;Χημική σύσταση μπαταρίας;A1.6;

  return (
    <Field
      name={name}
      title={label}
      component={(props) => (
        <CustomSelectComponent {...props} as={as} disabled={disabled} className="mb-0 p-0" />
      )}
      options={ChemistryOptions}
      useCreatableSelect={true}
      {...rest}
    />
  );
};
